import { axiosSwagger } from "@/axios";


export const state = {
    publicCategory: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // PUBLIC CATEGORY
    loading: (state, loading) => {
        state.publicCategory.loading = loading;
    },
    setData: (state, data) => {
        state.publicCategory.data = data;
    },
    setTotal: (state, total) => {
        state.publicCategory.total = total;
    }
}


export const actions = {
    // READ PUBLIC CATEGORY
    async readPublicCategory({ commit }) {
        commit("loading", true);

        return await axiosSwagger
        .get(`/api/FilePosting/Public/Categories`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    // eslint-disable-next-line no-unused-vars
    async readPublicFileByCategoryId({ commit }, id) {
        return await axiosSwagger
        .get(`/api/FilePosting/Public/Category/${id}`)
        .then((response) => {

            return response;
        });
    },
}